import applyConfigBlockAgendaSummary from './components/Blocks/AgendaSummary';
import applyConfigBlockAreaInfo from './components/Blocks/AreaInfo';
import applyConfigBlockCards from './components/Blocks/Cards';
import applyConfigBlockListingCards from './components/Blocks/ListingCards';
import applyConfigBlockListingPersons from './components/Blocks/ListingPersons';
import applyConfigBlockPersonData from './components/Blocks/Person';
import applyConfigBlockPersonAgenda from './components/Blocks/PersonAgenda';
import applyConfigBlockServices from './components/Blocks/Services';
import CompromissoView from './components/View/CompromissoView';
import CategoryWidget from './components/Widgets/CategoryWidget';
import { contentIcons } from './config/ContentIcons';
import applyConfigCustomValidations from './helpers/validations';
import * as addonReducers from './reducers';
import registerSlotComponents from './slotComponents';

import headsetMicrophoneSVG from '@plone/volto/icons/headset-microphone.svg';

const applyConfig = (config) => {
  registerSlotComponents(config);

  // Adiciona reducers do pacote.
  config.addonReducers = {
    ...config.addonReducers,
    ...addonReducers,
  };

  // Define os ícones do control panel.
  config.settings.controlPanelsIcons = {
    ...config.settings.controlPanelsIcons,
    'contact-info-properties': headsetMicrophoneSVG,
  };

  // Define o ícone para o tipo de conteúdo Pessoa
  config.settings.contentIcons = {
    ...config.settings.contentIcons,
    ...contentIcons,
  };

  config.views = {
    ...config.views,
    contentTypesViews: {
      ...config.views.contentTypesViews,
      Compromisso: CompromissoView,
    },
  };

  // INFO: a validacao de bloco de ordem de blocos depende desta configuração
  // ATENÇÃO: os blocos iniciais do News Item devem estar sincronizados na migração em:
  // https://gitcorporativo.serpro/sgc/govbr-volto-12677/volto.transmogrifier/-/blob/main/src/volto/transmogrifier/sections/initialize_blocks.py
  // Se a configuração for alterada, a migração deve ser atualizada.
  config.blocks.initialBlocks = {
    ...config.blocks.initialBlocks,
    Area: [
      { '@type': 'title' },
      { '@type': 'areaInfoBlock' },
      { '@type': 'listingPersonsBlock' },
    ],
    Agenda: [
      { '@type': 'title' },
      { '@type': 'description' },
      { '@type': 'dateSocialShareBlock' },
      { '@type': 'personAgendaBlock' },
    ],
    // Layout inicial para Pessoa:
    // title (fixo) + bloco de colunas (1/3 + 2/3)
    //  - Coluna esquerda: personDataBlock (cartão da pessoa)
    //  - Coluna direita: description + slate (bio / conteúdo livre)
    // OBS: IDs internos das colunas e blocos filhos são estáticos aqui apenas
    // para estruturar o objeto inicial; o Volto clonará top-level IDs, mas
    // manterá a hierarquia aninhada.
    Pessoa: [
      { '@type': 'title', fixed: true, required: true },
      {
        '@type': 'columnsBlock',
        gridSize: 12,
        gridCols: ['oneThird', 'twoThirds'],
        data: {
          // Estrutura interna das colunas (col blocks + layout)
          blocks: {
            // Coluna 1 (1/3)
            'col-person-data': {
              blocks: {
                'person-data-block': { '@type': 'personDataBlock' },
              },
              blocks_layout: { items: ['person-data-block'] },
              settings: {},
            },
            // Coluna 2 (2/3)
            'col-person-content': {
              blocks: {
                // Accordion inicial com um painel "Descrição" e bloco de texto dentro
                'person-accordion': {
                  '@type': 'accordion',
                  openOnStart: true,
                  data: {
                    blocks: {
                      'accordion-panel-1': {
                        title: 'Descrição',
                        blocks: {
                          'person-description': { '@type': 'description' },
                        },
                        blocks_layout: { items: ['person-description'] },
                      },
                      'accordion-panel-2': {
                        blocks: {
                          'panel-text': { '@type': 'slate' },
                        },
                        blocks_layout: { items: ['panel-text'] },
                      },
                    },
                    blocks_layout: {
                      items: ['accordion-panel-1', 'accordion-panel-2'],
                    },
                  },
                },
              },
              blocks_layout: {
                items: ['person-description', 'person-accordion'],
              },
              settings: {},
            },
          },
          blocks_layout: { items: ['col-person-data', 'col-person-content'] },
        },
      },
    ],
  };

  config.widgets.widget.category_widget = CategoryWidget;

  applyConfigBlockCards(config);
  applyConfigBlockListingCards(config);
  applyConfigBlockListingPersons(config);
  applyConfigBlockPersonAgenda(config);
  applyConfigBlockAgendaSummary(config);
  applyConfigBlockPersonData(config);
  applyConfigBlockAreaInfo(config);
  applyConfigBlockServices(config);

  applyConfigCustomValidations(config);

  return config;
};

export default applyConfig;
